export const GetInitials = (name) => {
    const nameParts = name.trim().split(" ");
    let initials = nameParts.map(part => part.charAt(0).toUpperCase());
    if (initials.length > 3) {
      initials = initials.slice(0, 3); // Only take the first 3 initials
    }
    return initials.join("");
}